const ALLOWED_RETURN_URL_ORIGINS = [
  'https://fm-apps-qa.digital-farming.com',
  'https://fm-apps.xarvio.com',
  //TEMPORARILY WHITELIST LOCALHOST FOR TESTING
  'http://localhost:5173',
  'https://localhost:5173',
];

const isAllowedOrigin = (origin: string): boolean =>
  origin === window.location.origin ||
  ALLOWED_RETURN_URL_ORIGINS.includes(origin);

const isSafeReturnUrl = (value: string): boolean => {
  const isRootRelativePath =
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.startsWith('/\\');
  const isAbsoluteHttpUrl = /^https?:\/\//i.test(value);

  if (!isRootRelativePath && !isAbsoluteHttpUrl) {
    return false;
  }

  try {
    const url = new URL(value, window.location.origin);
    return (
      isAllowedOrigin(url.origin) &&
      (isRootRelativePath ||
        url.protocol === 'http:' ||
        url.protocol === 'https:')
    );
  } catch {
    return false;
  }
};

export const getReturnUrl = (searchParams: URLSearchParams): string | null => {
  const returnUrl = searchParams.get('returnUrl');

  if (!returnUrl || !isSafeReturnUrl(returnUrl)) {
    return null;
  }

  return returnUrl;
};

export const appendHandoffToken = (
  returnUrl: string,
  token: string,
): string => {
  if (!token) {
    return returnUrl;
  }

  const url = new URL(returnUrl, window.location.origin);

  if (url.origin === window.location.origin) {
    return returnUrl;
  }

  url.searchParams.set('token', token);

  return url.href;
};
